import React from "react";
import HeroBanner from "components/sections/HeroBanner";
import ServicesSection from "./ServicesSection";
import OurVision from "components/sections/OurVision";

const ServicesPage = () => {
  return (
    <>
      <HeroBanner
        title="Services"
        subTitle="What We Offer"
        desc="From development to design, explore our wide range of services tailored to your needs."
      />
      <ServicesSection />
      <OurVision />
    </>
  );
};

export default ServicesPage;
